'use strict';

var moment = require('moment-timezone');
var Marionette = require('backbone.marionette');

var ServiceDurationCollection = require('../../collections/service-durations').default;

export default Marionette.View.extend({
  className: 'add-to-calendar',
  template: require('./templates/add-to-calendar.hbs'),

  initialize: function () {
    this.collection = new ServiceDurationCollection();
  },

  onRender: function () {
    if (this.collection.length === 0) {
      this.fetchDurations();
    }
  },

  serializeData: function () {
    return {
      icalLink: this.model.getICalLink(),
      googleLink: this.model.getGoogleLink(),
      yahooLink: this.model.getYahooLink(),
    };
  },

  fetchDurations: function () {
    var self = this;
    var user = this.model.get('staff_id');
    var data = {
      service_id: this.model.get('service_id'),
    };
    var services = this.model.services;
    var baseDuration = 0;

    for (var i = 0; i < services.length; i++) {
      var service = services[i];

      baseDuration += service.get('duration');
    }

    if (user) {
      data.staff_id = user;
    }

    this.collection.fetch({
      data: data,
      reset: true,
      success: function (durations) {
        var user = self.model.get('staff_id');
        var services = self.model.get('service_id');
        var duration = 0;

        for (var i = 0; i < services.length; i++) {
          var service = services[i];
          var options = {
            user_id: user,
            service_id: service,
          };
          var durationOptions = durations.findWhere(options);

          if (durationOptions) {
            duration += durationOptions.get('duration');
          }
        }

        duration = duration === 0 ? baseDuration : duration;

        var timezone = self.model.get('timezone');
        var end = moment.tz(self.model.get('start'), timezone).add(duration, 'm');

        self.model.set('client_end', end);

        self.render();
      },
    });
  },
});
